import { Row } from 'reactstrap';

export default function Subtitle({
  name,
  className,
}: {
  name: string;
  className?: string;
}): JSX.Element {
  return (
    <div className={className}>
      <Row className="ml-2">
        <h6 className="heading-small text-muted mb-1">{name}</h6>
      </Row>
      <hr className="mt-2" />
    </div>
  );
}
